import { ofisPayloadType, ofisRequestType } from "./ofis-dao.type";
import { getPreferredTimezone, sanitizeInput } from "src/utils/utils";

class ofisRequest {
	ofisPayload: ofisPayloadType
	request: ofisRequestType

	constructor(ofisPayload: ofisPayloadType) {
		ofisPayload.searchId=sanitizeInput(ofisPayload.searchId)
		this.ofisPayload = ofisPayload
		this.request = this.buildOfisRequest();
	}

	buildOfisRequest() : ofisRequestType {
		var ofisRequest: ofisRequestType = {
			inputId: this.ofisPayload.searchId.split(","),
			type: this.ofisPayload.searchType,
			docType: this.ofisPayload.documentType,
			size: this.ofisPayload.size || 10,
			offset: this.ofisPayload.offset || 0,
			facetConstraints: this.ofisPayload.facetFilters,
			timezone: getPreferredTimezone()
		}
		return ofisRequest;
	}
}

export default ofisRequest